export const redirectLogin = (navigate, location) => {
    console.log("redirect")
    navigate(`/login?previous=${location.pathname}`)
}
